import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgResize = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 24C11.447 24 11 23.553 11 23V1C11 0.447 11.447 0 12 0C12.553 0 13 0.447 13 1V23C13 23.553 12.553 24 12 24Z",
			fill: "#636C7B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 11H5V7L0 12L5 17V13H9V11Z",
			fill: "#636C7B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 11H19V7L24 12L19 17V13H15V11Z",
			fill: "#636C7B"
		})
	]
});
export default SvgResize;
